module.exports = __webpack_public_path__ + "static/media/A2-Mapbox__API.f4d5cd70.svg";